import React from 'react';
import { HEATMAP_SCORE_TYPE_TO_TITLE, HeatmapScoreType } from './HeatmapTypes';
import {
    FGSegmentedControl,
} from '@fg/design-system';

type Props = {
    currentScoreType: HeatmapScoreType;
    onChangeScoreType: (scoreType: HeatmapScoreType) => void;
};

const HeatmapScoreTypeSelection = React.memo(
    ({
        currentScoreType,
        onChangeScoreType,
    }: Props) => {
        return (
            <div className="heatmap-toggle">
                <FGSegmentedControl
                    selectedValue={currentScoreType}
                    name="Composite/Pulse"
                    onChange={(val: any) => onChangeScoreType(val)}
                    segments={[
                        HeatmapScoreType.PULSE,
                        HeatmapScoreType.RISK,
                    ].map(scoreType => ({
                        label: HEATMAP_SCORE_TYPE_TO_TITLE[scoreType],
                        value: scoreType,
                    }))}
                />
            </div>
        );
    }
);

export default HeatmapScoreTypeSelection;
